export * from './faq';

export * from './text';
export * from './html';
// Export shared types first
export * from './shared';
// Export specific block types
export * from './banner';
export * from './bundles';
export * from './banner-v2';
export * from './breadcrumb';
export * from './newsletter';
export * from './trial-offer';
export * from './coming-soon';
export * from './contact-form';
export * from './feature-tabs';
export * from './feature-steps';
export * from './image-text-v1';
export * from './review-slider';
export * from './big-image-text';
export * from './image-text-grid';
export * from './small-image-text';
export * from './text-and-service';
export * from './unit-pack-pricing';
export * from './suggested-features';
export * from './features-categories';
export * from './feature-services-tabs';
export * from './package-pricing-plans';
export * from './banner-with-white-text';

export enum BlockTypes {
  BANNER = 'hero--banner',
  NEWSLETTER = 'section--newsletter',
  CONTACT = 'section--contact',
  TRIAL_OFFER_V1 = 'section--trial-offer-v1',
  FEATURE_STEPS_V1 = 'section--feature-steps-v1',
  FEATURE_TABS_V1 = 'section--feature-tabs-v1',
  FEATURE_SERVICES_TABS = 'section--services-tabs',
  REVIEW_SLIDER = 'section--review-slider',
  PACKAGE_PRICING_PLANS = 'section--package-pricing-plans',
  UNIT_PACK_PRICING = 'section--unit-pack-pricing',
  FEATURES_CATEGORIES = 'section--features-categories',
  IMAGE_TEXT_V1 = 'section--image-text-v1',
  IMAGE_TEXT_V2 = 'section--image-text-v2',
  BANNER_V2 = 'section--banner-v2',
  BANNER_V3 = 'section--banner-v3',
  BANNER_WITH_WHITE_TEXT = 'section--banner-with-white-text',
  SUGGESTED_FEATURES = 'section--suggested-features',
  BREADCRUMB = 'section--breadcrumb',
  FAQ = 'section--faq',
  IMAGE_TEXT_GRID = 'section--image-text-grid',
  BIG_IMAGE_TEXT = 'section--big-image-text',
  SMALL_IMAGE_TEXT = 'section--small-image-text',
  TEXT_AND_SERVICE = 'section--text-and-service',
  TEXT = 'section--text',
  HTML = 'section--html',
  COMING_SOON = 'section--coming-soon',
  ERROR_500 = 'section--page-500',
  ERROR_404 = 'section--page-404',
  ERROR_403 = 'section--page-403',
}

// Re-export for backward compatibility
export const Blocks = {
  TechnicalName: BlockTypes,
};

// Union type for all block contents (useful for CMS/dynamic rendering)
